import type { RouteApi } from '~/schema/RouteApiSchema'

export const API_LOGIN: RouteApi = {
  method: HttpMethod.POST,
  path: '/login'
}

export const API_LOGOUT: RouteApi = {
  method: HttpMethod.GET,
  path: '/logout'
}

export const API_ME: RouteApi = {
  method: HttpMethod.GET,
  path: '/me'
}
